// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__3+VoW","create-modal":"styles_create-modal__yEx5T"};